import {Action} from "@ngrx/store";

export const LOAD_ECOMMERCE_GENERAL_SETTINGS: string = '[ecommerce General Settings] Load Ecommerce General Settings';
export const LOAD_ECOMMERCE_GENERAL_SETTINGS_SUCCESS: string = '[ecommerce General Settings] Load Ecommerce General Settings Success';
export const LOAD_ECOMMERCE_GENERAL_SETTINGS_FAIL: string = '[ecommerce General Settings] Load Ecommerce General Settings Fail';

export class LoadEcommerceGeneralSettings implements Action {
  readonly type: string = LOAD_ECOMMERCE_GENERAL_SETTINGS;

  constructor(public payload: { websiteId: number }) {
  }
}

export class LoadEcommerceGeneralSettingsSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_GENERAL_SETTINGS_SUCCESS;

  constructor(public payload: {
    data: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommerceGeneralSettingsFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_GENERAL_SETTINGS_FAIL;

  constructor(public payload: any) {
  }

}

export type EcommerceGeneralSettingsAction = LoadEcommerceGeneralSettings | LoadEcommerceGeneralSettingsSuccess | LoadEcommerceGeneralSettingsFail;
